import { BiQueryResult } from '@euler/model/bi/result';
import { BiVizSpec } from '@euler/model/bi/viz';
import dayjs from 'dayjs';

/** The dates a result's range resolved to: `2026-08-01 至 2026-10-17`. */
export function biWindowCaption(result: BiQueryResult): string | null {
  const { window } = result;
  if (!window) return null;
  return window.from === window.to
    ? window.from
    : `${window.from} 至 ${window.to}`;
}

/**
 * The line under a card's title: its own subtitle, the dates the data
 * covers (a title names the period as said, never these dates), then when
 * the data was read.
 */
export function biCardSubtitle(viz: BiVizSpec, result: BiQueryResult): string {
  const own = viz.style?.subtitle?.trim();
  const asOf = `数据截至 ${dayjs(result.asOf).format('M月D日 HH:mm')}`;
  return [own, biWindowCaption(result), asOf].filter(Boolean).join(' · ');
}
